import React from 'react'
import map from 'lodash/map'
import times from 'lodash/times'
import find from 'lodash/find'
import classNames from 'classnames'
import Icon from '../shared/icon'
import { ReplenishmentOrder, OilReplenishment } from './types'
import { t } from "../../i18n"

const AmountBar = ({ replenishedSlot, replenishmentView, maxAmount, remainingAmount, replenishedAmount, amountStatus,  }) => {

  const remainingAmountStatus = () => {
    if(remainingAmount > 100) {
      return 'ok'
    }
    return 'warning'
  }

  const maxAmountBarSteps = 25

  const remainingBarSteps = Math.ceil(remainingAmount * (maxAmountBarSteps / maxAmount))
  let replenishedSteps = Math.ceil(replenishedAmount * (maxAmountBarSteps / maxAmount))
  const emptyBarSteps = maxAmountBarSteps - (remainingBarSteps + replenishedSteps)

  if(emptyBarSteps < 0) {
    replenishedSteps = replenishedSteps + emptyBarSteps
  }

  return (
    <>
      {(!!replenishedSlot && replenishmentView) ?
        <>
          <div className={`amount-bar status-replenished`}>
            {times(emptyBarSteps, i =>
              <div key={i} className='amount-bar-step replenished-empty'></div>
            )}
          </div>

          <div className={`amount-bar status-replenished`}>
            {times(replenishedSteps, i =>
              <div key={i} className='amount-bar-step'></div>
            )}
          </div>

          <div className={`amount-bar status-${remainingAmountStatus()}`}>
            {times(remainingBarSteps, i =>
              <div key={i} className={`amount-bar-step ${i == 0 ? 'first' : ''}`}></div>
            )}
          </div>
        </> :
        <div className={`amount-bar status-${amountStatus}`}>
          {times(maxAmountBarSteps, i =>
            <div key={i} className={`amount-bar-step ${i < (maxAmountBarSteps - remainingBarSteps) ? 'empty' : ''}`}></div>
          )}
        </div>
      }
    </>
  )
}

interface OilContainerSlotProps {
  oilLevel: {
    oil_remaining: number,
    oil_capacity: number,
    oil_status: string
  }
  expandOilContainer: Function,
  replenishmentView?: boolean,
  replenishedSlot?: OilReplenishment | null,
  activeReplenishmentOrders?: ReplenishmentOrder[],
  weightScale: string
}

const OilContainerSlot: React.FC<OilContainerSlotProps> = ({
  oilLevel, expandOilContainer,replenishmentView,
  replenishedSlot, activeReplenishmentOrders, weightScale
}) => {

  const maxAmount = oilLevel.oil_capacity
  const remainingAmount = oilLevel.oil_remaining || 0
  const replenishedAmount = replenishedSlot ? replenishedSlot.amount : 0

  const hasSentReplenishment = () => {
    if(!activeReplenishmentOrders) return false
    return !!find(
      activeReplenishmentOrders,
      (order: ReplenishmentOrder) => !!order.oilReplenishment && order.oilReplenishment.state !== 'canceled'
    )
  }

  const oilStatus = () => {
    if (!!replenishedSlot && replenishmentView) {
      return t('stock_control.oil_status.marked_for_replenishment')
    }

    return t(`stock_control.oil_status.${oilLevel.oil_status}`)
  }

  const amountStatus = () => {
    if(!!replenishedSlot) {
      return 'replenished'
    } else if(remainingAmount > 2000) {
      return 'ok'
    }
    return 'warning'
  }

  const containerClassNames = classNames(
    'plate-container', 'oil-container',
    {
      'replenishment': replenishmentView,
      'replenished': !!replenishedSlot && replenishmentView,
    }
  )

  return (
    <div className={containerClassNames}  onClick={() => expandOilContainer()}>
      {hasSentReplenishment() && replenishmentView &&
        <span className="replenishment-sent-corner-status"></span>
      }
      <AmountBar
        replenishedSlot={replenishedSlot}
        replenishmentView={replenishmentView}
        maxAmount={maxAmount}
        remainingAmount={remainingAmount}
        replenishedAmount={replenishedAmount}
        amountStatus={amountStatus()}
      />
      <div className='amount'>
        <div className='remaining-amount' style={{maxWidth: '90px'}}>
          <span className={`status-${amountStatus()}`}>{oilStatus()}</span>
        </div>
      </div>
      <div className="edit-plate-container">
        <div className='plate-icon'>
        </div>
        <div className='container-name'>Oil tank</div>
      </div>
    </div>
  )
}

interface OilViewProps {
  oilLevel: {
    oil_remaining: number,
    oil_capacity: number
  }
  expandOilContainer: Function,
  replenishmentView: boolean,
  draftReplenishmentOrder: ReplenishmentOrder,
  isSelectedTab: boolean,
  activeReplenishmentOrders: ReplenishmentOrder[],
  weightScale: string
}


const OilView: React.FC<OilViewProps> = ({
  oilLevel, expandOilContainer, replenishmentView,
  draftReplenishmentOrder, isSelectedTab, activeReplenishmentOrders, weightScale
}) => {

  const oilReplenishment = () => {
    return draftReplenishmentOrder?.oilReplenishment || null
  }


  return (
    <div className='tab-content plates' style={{maxWidth: isSelectedTab ? '100%' : '0'}}>
      <div className='plates-wrapper'>
          <OilContainerSlot
            key={'oil-level'}
            oilLevel={oilLevel}
            expandOilContainer={expandOilContainer}
            replenishmentView={replenishmentView}
            replenishedSlot={oilReplenishment()}
            activeReplenishmentOrders={activeReplenishmentOrders}
            weightScale={weightScale}
          />
      </div>
    </div>
  )
}

export default OilView;
